module.exports = __webpack_public_path__ + "img/27.e2e679bb.jpg";